import { TFunction } from "i18next";
import { Dispatch, FC, SetStateAction } from "react";
import { useTranslation } from "react-i18next";
import {
  Checkbox,
  ChoiceChip,
  HStack,
  Stack,
  Text,
} from "shared/components/Spor";
import { toggle } from "shared/utils/objectUtils";

export type Weekday = {
  name: string;
  dayNumber: number;
};

export const getDaysOfWeek = (
  translate: TFunction<"translation", undefined>,
): Weekday[] => [
  { name: translate("man"), dayNumber: 0 },
  { name: translate("tir"), dayNumber: 1 },
  { name: translate("ons"), dayNumber: 2 },
  { name: translate("tor"), dayNumber: 3 },
  { name: translate("fre"), dayNumber: 4 },
  { name: translate("lør"), dayNumber: 5 },
  { name: translate("søn"), dayNumber: 6 },
];

type DayChoiceProps = {
  selectedDays: number[];
  setSelectedDays: Dispatch<SetStateAction<number[]>>;
};

export const DayChoice: FC<DayChoiceProps> = ({
  selectedDays,
  setSelectedDays,
}) => {
  const { t } = useTranslation();
  return (
    <Stack paddingTop="18px" paddingBottom="18px">
      <Text variant="xs">Hendelsen er aktiv hver</Text>
      <HStack>
        {getDaysOfWeek(t).map((day) => (
          <ChoiceChip
            key={day.dayNumber}
            checked={selectedDays.includes(day.dayNumber)}
            onCheckedChange={() =>
              setSelectedDays(toggle(selectedDays, day.dayNumber))
            }
            size="sm"
          >
            <Text fontWeight="400">{day.name}</Text>
          </ChoiceChip>
        ))}
      </HStack>
      <Checkbox
        checked={selectedDays.length === 7}
        onCheckedChange={() =>
          setSelectedDays(
            selectedDays.length === 7 ? [] : [0, 1, 2, 3, 4, 5, 6],
          )
        }
      >
        {t("Alle dager")}
      </Checkbox>
    </Stack>
  );
};
